import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	doneLabel: {
		id: 'business-timeline.timeline-view.chart-item-content.bar-content.bar-icon.done-label',
		defaultMessage: 'Done',
		description: 'Label for done issues',
	},
	viewDetail: {
		id: 'business-timeline.timeline-view.chart-item-content.bar-content.bar-icon.view-detail',
		defaultMessage: 'View dependency details',
		description: 'Tooltip text. Appears on the dependencies icon on the bar, when hovering.',
	},
});
